import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import villa1 from "../../images/home/vacation1.png";
import villa2 from "../../images/home/vacation2.png";
import villa3 from "../../images/home/vacation3.png";
import villa4 from "../../images/home/vacation4.png";
import villa5 from "../../images/home/sliderMain.png";
import villa6 from "../../images/home/vacation6.png";

const Vacation = () => {
  return (
    <div className="relative text-white md:py-10 py-4 max-md:px-4 max-w-[1440px] mx-auto">
      <div className="text-xl text-[#585858] poppins-medium text-center">
        EXPLORE VILLA
      </div>
      <div className=" mt-2 tracking-wide md:tracking-wider mx-auto flex justify-center text-center md:w-[600px] md:leading-snug text-2xl md:text-[46px] font-bold text-[#672220]">
        See Villa You’ll Love to Book for Vacations
      </div>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{ delay: 10000}}
        loop={true}
        navigation
        breakpoints={{
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        }}
        className="mt-8"
      >
        <SwiperSlide>
          <div className="rounded-xl overflow-hidden shadow-lg mt-20 transition-all duration-300">
            <img
              src={villa1}
              alt="Villa 1"
              className="w-full md:h-[360px] object-cover filter grayscale hover:grayscale-0 transition-all duration-300"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="rounded-xl overflow-hidden transition-all duration-300">
            <img
              src={villa2}
              alt="Villa 2"
              className="w-full md:h-[240px] object-cover filter grayscale hover:grayscale-0 transition-all duration-300"
            />
            <img
              src={villa3}
              alt="Villa 3"
              className="w-full md:h-[240px] object-cover mt-2 filter grayscale hover:grayscale-0 transition-all duration-300"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="rounded-xl overflow-hidden transition-all duration-300">
            <img
              src={villa4}
              alt="Villa 4"
              className="w-full md:h-[354px] object-cover filter grayscale hover:grayscale-0 transition-all duration-300"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="overflow-hidden transition-all duration-300">
            <img
              src={villa5}
              alt="Villa 5"
              className="w-full h-[400px] md:h-[530px] object-cover filter grayscale hover:grayscale-0 transition-all duration-300"
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="rounded-xl overflow-hidden shadow-lg mt-10 transition-all duration-300">
            <img
              src={villa6}
              alt="Villa 6"
              className="w-full md:h-[363px] object-cover filter grayscale hover:grayscale-0 transition-all duration-300"
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Vacation;
